import { Modal, message, Select, Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { putRequest, getRequest } from "../../service";
import { getChangedFields } from "../../utils/getChangedFields";

const LeavesEdit = (props) => {
  const { open, onRequestClose, employee } = props;
  const [form, setForm] = useState({
    annual_leave_policy: []
  });
  const originalFormRef = useRef({});
  const [leaveConfigs, setLeaveConfigs] = useState([]);

  useEffect(() => {
    if (employee) {
      const initialData = {
        annual_leave_policy: employee.annual_leave_policy || []
      };
      setForm(initialData);
      originalFormRef.current = initialData;
    }
  }, [employee]);

  useEffect(() => {
    fetchLeaveConfigs();
  }, []);

  const fetchLeaveConfigs = async () => {
    try {
      const response = await getRequest('/api/leaves');
      if (response?.leaveConfigs) {
        setLeaveConfigs(response.leaveConfigs);
      }
    } catch (error) {
      console.error('Error fetching leave configs:', error);
    }
  };

  const handlePolicyChange = (value) => {
    setForm(prev => ({
      ...prev,
      annual_leave_policy: value
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = getChangedFields(originalFormRef.current, form);
      if (Object.keys(payload).length === 0) {
        message.info("No changes to update");
        return;
      }
      const response = await putRequest(`/api/employees?employeeId=${employee._id}`, payload);
      if (response.message === 'Employee updated successfully (some related data could not be loaded)') {
        message.success('Employee updated successfully')
        onRequestClose();
      }
      else {
        message.error(response.message || "Employee not updated")
      }
    } catch (error) {
      console.error('Error updating employee:', error);
    }
  };

  const leaveOptions = leaveConfigs.map(config => ({
    value: config._id,
    label: config.title
  }));

  return (
    <Modal
      title="Leave Information"
      open={open}
      onCancel={onRequestClose}
      footer={null}
      width={800}
    >
      <div className="flex items-start justify-between bg-white h-[50vh] overflow-auto">
        <div className="bg-form-bg w-full rounded-md px-4 py-8">
          <div className="grid grid-cols-1 gap-4">
            <div className="flex flex-col gap-1">
              <label htmlFor="annual_leave_policy" className="text-md">
                Leave Policy <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <Select
                mode="multiple"
                className="w-full"
                placeholder="Select leave policies"
                onChange={handlePolicyChange}
                value={form.annual_leave_policy}
                options={leaveOptions}
              />
            </div>

            <div className="mt-4">
              <table className="w-full rounded-md">
                <thead>
                  <tr className="bg-tablehead">
                    <th className="px-2 py-2 text-md font-normal">Title</th>
                    <th className="px-2 py-2 text-md font-normal">Duration</th>
                    <th className="px-2 py-2 text-md font-normal">Days</th>
                  </tr>
                </thead>
                <tbody>
                  {form.annual_leave_policy.map((policyId, index) => {
                    const policy = leaveConfigs.find(config => config._id === policyId);
                    return policy ? (
                      <tr className="border border-tablehead" key={index}>
                        <td className="px-2 py-2 text-md text-center">{policy.title}</td>
                        <td className="px-2 py-2 text-md text-center">{policy.leaveDuration || '-'}</td>
                        <td className="px-2 py-2 text-md text-center">{policy.numberOfDays}</td>
                      </tr>
                    ) : null;
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-2">
        <Button onClick={onRequestClose} >Cancel</Button>
        <Button
          onClick={handleSubmit}
          type="primary"
          className="bg-primary text-white"
        >
          Update Leaves
        </Button>
      </div>
    </Modal>
  );
};

export default LeavesEdit;
